export const mediumBlack = 'rgba(0, 0, 0, 0.6)'
export const mediumWhite = 'rgba(255, 255, 255, 0.75)'
export const kashmirBlue = 'rgb(74, 108, 158)'
export const kashmirBlueHover = 'rgba(74, 108, 158, 0.8)'
export const chambray = '#304e7c'
